import { LazyLoadedStates, LazyLoadedStatesManager } from '@edl-development/edl-common';

export const RatingFormLazyLoadedStates = new LazyLoadedStatesManager<{
    base: LazyLoadedStates,
    ratingFormDetails: LazyLoadedStates
}> ({
    base: {
        name: 'authenticated.user-summary.rating-form',
        url: '/rating-form'
    },
    ratingFormDetails: {
        name: 'authenticated.user-summary.rating-form.details',
        url: '/details/:userId/:observationId?edit'
    }
},
() => import('src/app/observations/rating-forms/rating-forms.module')
    .then((result: { RatingFormsModule: any }) => result.RatingFormsModule)
);
